import script from "./CouleursPickerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouleursPickerModal.vue?vue&type=script&setup=true&lang=ts"

import "./CouleursPickerModal.vue?vue&type=style&index=0&id=65856ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65856ef4"]])

export default __exports__